import React from 'react';

import IconsMapper from 'common/components/IconsMapper/IconsMapper';

const getNetworkName = (icon) => {
  const networkNames = {
    faFacebook: 'Facebook',
    faInstagram: 'Instagram',
  };
  return networkNames[icon] || 'Réseau social';
};

const Networks = ({ networks = [] }) => {
  if (!networks || networks.length === 0) {
    return null;
  }

  return (
    <div
      className="sl-flex sl-ai-center sl-gap"
      role="navigation"
      aria-label="Réseaux sociaux"
      itemProp="sameAs"
    >
      {networks.map((network) => {
        const networkName = getNetworkName(network.icon);
        return (
          <a
            key={network.icon}
            href={network.url}
            target="_blank"
            rel="nofollow noopener noreferrer"
            aria-label={`Suivez-nous sur ${networkName}`}
            title={networkName}
            itemProp="sameAs"
          >
            <IconsMapper
              icon={network.icon}
              style={{
                fontSize: 'var(--fontsize-xxl)',
                color: '#9d9d9c',
              }}
              aria-hidden="true"
            ></IconsMapper>
            <span className="sr-only">{networkName}</span>
          </a>
        );
      })}
    </div>
  );
};

export default Networks;